var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$utils.isPhone())?_c('sub-h5-home'):_c('sub-pc-home')
}
var staticRenderFns = []

export { render, staticRenderFns }